import React, { Component } from 'react';
import { Tabs, Toolbar, Button, Divider } from '@redux-devtools/ui';
import { connect } from 'react-redux';
import { GoBook } from 'react-icons/go';
import { IoMdText } from 'react-icons/io';
import { TiSocialTwitter } from 'react-icons/ti';
import { TiHeartFullOutline } from 'react-icons/ti';
import { changeSection } from '../actions/index.js';
const tabs = [{ name: 'Actions' }, { name: 'Settings' }];
class Header extends Component {
    constructor() {
        super(...arguments);
        this.openLink = (url) => () => {
            window.open(url);
        };
    }
    render() {
        return (React.createElement(Toolbar, { compact: true, noBorder: true, borderPosition: "bottom" },
            React.createElement(Tabs, { main: true, collapsible: true, tabs: tabs, onClick: this.props.changeSection, selected: this.props.section || 'Actions' }),
            React.createElement(Divider, null),
            React.createElement(Button, { title: "Documentation", tooltipPosition: "bottom", onClick: this.openLink('https://github.com/reduxjs/redux-devtools/blob/main/README.md') },
                React.createElement(GoBook, null)),
            React.createElement(Button, { title: "Feedback", tooltipPosition: "bottom", onClick: this.openLink('https://github.com/reduxjs/redux-devtools/discussions') },
                React.createElement(IoMdText, null)),
            React.createElement(Button, { title: "Follow us", tooltipPosition: "bottom", onClick: this.openLink('https://twitter.com/NathanBierema') },
                React.createElement(TiSocialTwitter, null)),
            React.createElement(Button, { title: "Support us", tooltipPosition: "bottom-left", onClick: this.openLink('https://opencollective.com/redux-devtools-extension') },
                React.createElement(TiHeartFullOutline, null))));
    }
}
const actionCreators = {
    changeSection,
};
export default connect(null, actionCreators)(Header);
